import { createSlice } from "@reduxjs/toolkit";

export const ideaModelDataSlice = createSlice({
    name: 'ideaModelData',
    initialState: {
        id: null
    },
    reducers:{
        setId(state, action) {
            state.id = action.payload
        }
    }
})


export const ideaModelDataActions = ideaModelDataSlice.actions